module.exports = __webpack_public_path__ + "img/to-chat-list-button-arrow.d37a02f1.svg";